import axios from 'axios';

export async function saveInquiry(stage, payload) {
  if (window.location.hostname === 'localhost') {
    console.log(`inquiry call ${stage}, ${JSON.stringify(payload)}`);
    return;
  }
  const apiUrl = process.env.REACT_APP_INQUIRY_API_URL || process.env.REACT_APP_INQUIRY_DEV_API_URL;
  if (!apiUrl) throw new Error('문의 API 주소를 설정하세요.');
  const storageKey = `inquiry-request:${stage}:${JSON.stringify(payload)}`;
  const requestKey = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  sessionStorage.setItem(storageKey, requestKey);
  const requestBody = {
    stage, requestKey, payload: { ...payload, SourceSite: 'promotionym' },
    name: payload.UserName || payload.BookerName,
    phone: payload.PhoneNumber || payload.UserPhone || payload.BookerPhoneNumber,
    email: payload.EmailAddress || payload.UserEmail || payload.BookerEmailAddress,
    inflowId: payload.Inflow || payload.Route || 'website',
  };
  const { data } = await axios.post(apiUrl, requestBody);
  sessionStorage.removeItem(storageKey);
  return data.result;
}

// https://promotionym.mosiler.com/booking/subscription?estimateinfo=JTdCJTIyVXNlck5hbWUlMjIlM0ElMjJyaXNlJTIyJTJDJTIyUGhvbmVOdW1iZXIlMjIlM0ElMjIwMTA4NzIyMzgzNCUyMiUyQyUyMkVtYWlsQWRkcmVzcyUyMiUzQSUyMnJpc2UlNDBtb3NpbGVyLmNvbSUyMiU3RA==&inflow=test
